export const SORT_TYPES = {
  text: { asc: 'A \u2192 Z', desc: 'Z \u2192 A' },
  date: { asc: 'Earliest \u2192 Latest', desc: 'Latest \u2192 Earliest' },
  number: { asc: '1 \u2192 9', desc: '9 \u2192 1' },
  currency: { asc: 'Lowest \u2192 Highest', desc: 'Highest \u2192 Lowest' },
};

export const SETTLEMENTS_COLUMNS = [
  { id: 'event_date', label: 'Event Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'event_name', label: 'Event Name', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'artist_name', label: 'Artist Name', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'venue_name', label: 'Venue Name', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'payment_status', label: 'Payment Status', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'settlement_paid_at', label: 'Settlement Paid At', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'payment_method', label: 'Payment Method', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'notes', label: 'Notes', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'total_due', label: 'Total Due', alwaysVisible: false, defaultVisible: true, sortable: false },
];

export const getDefaultVisibleColumns = () =>
  SETTLEMENTS_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  SETTLEMENTS_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
